import { FunctionComponent, useState } from "react";
import { userTypes } from "src/utils/types";
import FinancialKnowledgeDisplay from "./FinancialKnowledgeDisplay";
import EmploymentInfoDisplay from "./EmploymentInfoDisplay";
import LoanTypeDisplay from "./LoanTypeDisplay";
import FinancialHistoryDisplay from "./FinancialHistoryDisplay";
import FinancialGoalsDisplay from "./FinancialGoalsDisplay";
import SquareTile from "src/components/generic/tiles/SquareTile";

interface IClientNEATTProps {
    client: userTypes.Client;
}

const ProfileCompletion: FunctionComponent<IClientNEATTProps> = ({client}) => {
    const [tab, setTab] = useState<string>('fk');
    const tabOptions = [
        {label: 'Financial Knowledge', id: 'fk'},
        {label: 'Employment Information', id: 'ei'},
        {label: 'Loan Type', id: 'lt'},
        {label: 'Financial History', id: 'fh'},
        {label: 'Financial Goals', id: 'fg'},
    ];

    const financialKnowldge = client?.neatt?.fk;
    const financialKnowldgeComplete = financialKnowldge ? Object.keys(financialKnowldge)?.length === 7 : false;

    const employmentInfo = client?.neatt?.ei;
    const employmentInfoComplete = employmentInfo ? Object.keys(employmentInfo)?.length === 6 : false;
 
    const loanType = client?.neatt?.lt;
    const loanTypeComplete = loanType ? Object.keys(loanType)?.length === 4 : false;

    const financialHistory = client?.neatt?.fh;
    const financialHistoryComplete = financialHistory ? true : false;

    const financialGoals = client?.neatt?.fg;
    const financialGoalsComplete = financialGoals ? Object.keys(financialGoals)?.length === 12 : false;
    
    const renderContent = () => {
        switch(tab) {
            case tabOptions[0].id:
                return (financialKnowldgeComplete && financialKnowldge) ? <FinancialKnowledgeDisplay financialKnowledge={financialKnowldge} />
                : <FormIncompleteStatus formName={tabOptions[0].label} />;
            
            case tabOptions[1].id:
                return (employmentInfoComplete && employmentInfo) ? <EmploymentInfoDisplay employmentInfo={employmentInfo} />
                : <FormIncompleteStatus formName={tabOptions[1].label} />;

            case tabOptions[2].id:
                return (loanTypeComplete && loanType) ? <LoanTypeDisplay loanType={loanType} />
                : <FormIncompleteStatus formName={tabOptions[2].label} />

            case tabOptions[3].id:
                return (financialHistoryComplete && financialHistory) ? <FinancialHistoryDisplay financialHistory={financialHistory} />
                : <FormIncompleteStatus formName={tabOptions[3].label} />

            case tabOptions[4].id:
                return (financialGoalsComplete && financialGoals) ? <FinancialGoalsDisplay financialGoals={financialGoals} />
                : <FormIncompleteStatus formName={tabOptions[4].label} />
        }
    }

    const changeTab = (newTab: string) => setTab(newTab);

    if(!Object.keys(client)?.length) return <></>;

    return (
        <SquareTile>
            <div className="flex w-full">
                {
                    tabOptions.map((option: {label: string, id: string}) => (
                        <div
                            onClick={() => changeTab(option.id)}
                            className={`w-full flex items-center justify-center first:rounded-l-lg last:rounded-r-lg py-2 px-1 cursor-pointer border border-primary text-xs ${tab === option.id ? 'bg-primary text-white' : 'bg-white text-primary'}`}
                        >
                            <p>{option.label}</p>
                        </div>
                    ))
                }
            </div>

        <div className="text-md mt-10">
            {renderContent()}
        </div>
    </SquareTile>
    )
}

export default ProfileCompletion;

interface IFormIncompleteStatusProps {
    formName: string;
}

const FormIncompleteStatus: FunctionComponent<IFormIncompleteStatusProps> = ({ formName }) => (
    <div>
        <p>Client Has Not Completed the {formName} Form</p>
    </div>
);